// The in-stock snapshot is about 3 MB (13.5 MB of rows once unpacked). The browser keeps the last copy it downloaded in IndexedDB and shows it at once on the next visit;
// the server is then asked only whether anything changed. Everything here is optional: with storage blocked (a private window) the table simply waits for the download.
import type { InStockData } from "./actions";

const DB = "hec-sheet", STORE = "kv", KEY = "instock";

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function loadSaved(): Promise<InStockData | null> {
  try {
    const db = await open();
    return await new Promise((resolve) => {
      const get = db.transaction(STORE, "readonly").objectStore(STORE).get(KEY);
      get.onsuccess = () => { const v = get.result as InStockData | undefined; resolve(v && v.built && Array.isArray(v.rows) && Array.isArray(v.columns) ? v : null); };
      get.onerror = () => resolve(null);
    });
  } catch { return null; }
}

export async function saveCopy(data: InStockData): Promise<void> {
  try {
    const db = await open();
    await new Promise<void>((resolve) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).put(data, KEY);
      tx.oncomplete = () => resolve();
      tx.onerror = () => resolve();
    });
  } catch { /* storage blocked: nothing is kept, the next visit downloads again */ }
}
